<template>
  <div class="keluar">
    <BackSection :menu="name" />
    <div class="container-fluid py-2">
      <FormAbsenKeluar />
    </div>
  </div>
</template>
<script>
import FormAbsenKeluar from "@/components/FormAbsenKeluar.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      name: "Absen Keluar",
    };
  },
  components: {
    BackSection,
    FormAbsenKeluar,
  },
};
</script>
